import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import * as localforage from 'localforage';

@Component({
  selector: 'app-ganadores',
  templateUrl: './ganadores.component.html',
  styleUrls: ['./ganadores.component.scss']
})
export class GanadoresComponent implements OnInit {
  public data:any = {
    hora_inicio:"13:00",
    horasJuego:5,
    cubrebocas:{
      n:30,
      win:[],
    },
    desc10:{
      n:40,
      win:[],
    },
    desc15:{
      n:40,
      win:[],
    },
  };
  public premios:any = [];
  public cubrebocas_today:any;
  public desc10_today:any;
  public desc15_today:any;
  public serial:any = "Sin numero de serie";
  @Output() public home: EventEmitter<any> = new EventEmitter;
  constructor(private cookieService: CookieService) { }

  ngOnInit() {
    localforage.getItem('game-history').then((value:string)=> {
      if(value){
        this.data = JSON.parse(value)
        //console.log(this.data)
        for(let c of this.data.cubrebocas.win){
          for(let w of c.w){
            this.premios.push({hour:w,date:c.date,name:"Cubrebocas."})
          }
        }
        for(let c of this.data.desc10.win){
          for(let w of c.w){
            this.premios.push({hour:w,date:c.date,name:"10% de descuento."})
          }
        }
        for(let c of this.data.desc15.win){
          for(let w of c.w){
            this.premios.push({hour:w,date:c.date,name:"15% de descuento."})
          }
        }
        console.log(new Date('2020-11-04T19:55:00Z'))
        var premios = this.premios.sort(function(a, b) {
          var dateA:any = new Date(a.date+'T'+a.hour+':00Z'), dateB:any = new Date(b.date+'T'+b.hour+':00Z');
          return dateB - dateA;
          });
          console.log(premios)
        this.premios = premios

        var date = new Date()
        var hour = date.getHours();
        var minutes = date.getMinutes();
        var day = date.getDate()
        var month = date.getMonth()
        month = month + 1 
        var year = date.getFullYear()
        var str_day = day+""
        var str_month = month+""
        if(day<10){
          str_day = '0'+day
        }
        if(month<10){
          str_month = '0'+month
        }

        var cubrebocas_number_winners_today = 0
        var desc10_number_winners_today = 0
        var desc15_number_winners_today = 0
    
        if(this.data.cubrebocas.win.length != 0){
          console.log(year+"-"+str_month+"-"+str_day)
          for(let win of this.data.cubrebocas.win){
            if(win.date == year+"-"+str_month+"-"+str_day){
              if(win.w.length>0){
                cubrebocas_number_winners_today = win.w.length
              }
            }
          }
        }
        if(this.data.desc10.win.length != 0){
          console.log(year+"-"+str_month+"-"+str_day)
          for(let win of this.data.desc10.win){
            if(win.date == year+"-"+str_month+"-"+str_day){
              if(win.w.length>0){
                desc10_number_winners_today = win.w.length
              }
            }
          }
        }
        if(this.data.desc15.win.length != 0){
          console.log(year+"-"+str_month+"-"+str_day)
          for(let win of this.data.desc15.win){
            if(win.date == year+"-"+str_month+"-"+str_day){
              if(win.w.length>0){
                desc15_number_winners_today = win.w.length
              }
            }
          }
        }
        this.cubrebocas_today = cubrebocas_number_winners_today
        this.desc10_today = desc10_number_winners_today
        this.desc15_today = desc15_number_winners_today
      }
    }).catch(function(err) {
        // This code runs if there were any errors
        console.log(err);
    });
    const serial: boolean = this.cookieService.check('serial-number');

    if(serial){
      this.serial = this.cookieService.get('serial-number')
    }
  }
  
  goToHome(){
    this.home.emit(true);
  }

}
